import { colors } from '../../../ui-components';

class ContentRichText {
  constructor(contentfulNode) {
    this.title = contentfulNode?.title;
    this.centerText = contentfulNode?.centerRichTextContent || false;
    this.richJSON = contentfulNode?.richTextContent;
    this.formType = contentfulNode?.contactFormType;
    this.type = 'CONTENT_RICH';
    this.defaultColor = colors.pureWhite;
    this.formTitle = contentfulNode?.contactFormTitle;
    this.downloadableContent = contentfulNode?.downloadableContent;
  }
}

export { ContentRichText };
